import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_18 = { class: "form-check" }

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productMiscellneous',
  setup(__props) {

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const miscellaneousData = productGroup.miscellaneous
        compState.requiredMemo = miscellaneousData.requiredMemo
        compState.memo = miscellaneousData.memo
        compState.ageVerificationRequired = miscellaneousData.ageVerificationRequired
        compState.noMembershipDiscountAllowed = miscellaneousData.noMembershipDiscountAllowed
        compState.nonDiscountable = miscellaneousData.nonDiscountable
        compState.nonSurchargeable = miscellaneousData.nonSurchargeable
    }
})

const compState = reactive({
    requiredMemo: false,
    memo: '',
    ageVerificationRequired: false,
    noMembershipDiscountAllowed: false,
    nonDiscountable: false,
    nonSurchargeable: false
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const miscellaneousData = productGroup.miscellaneous
        compState.requiredMemo = miscellaneousData.requiredMemo
        compState.memo = miscellaneousData.memo
        compState.ageVerificationRequired = miscellaneousData.ageVerificationRequired
        compState.noMembershipDiscountAllowed = miscellaneousData.noMembershipDiscountAllowed
        compState.nonDiscountable = miscellaneousData.nonDiscountable
        compState.nonSurchargeable = miscellaneousData.nonSurchargeable
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        miscellaneous: {
            requiredMemo: newVal.requiredMemo,
            memo: newVal.memo,
            ageVerificationRequired: newVal.ageVerificationRequired,
            noMembershipDiscountAllowed: newVal.noMembershipDiscountAllowed,
            nonDiscountable: newVal.nonDiscountable,
            nonSurchargeable: newVal.nonSurchargeable
        }
    })

}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Single-Item-Select",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.requiredMemo) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.requiredMemo]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "form-check-label",
            for: "Single-Item-Select"
          }, "Memo Required", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Memo")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.memo) = $event)),
          class: "form-control",
          type: "text",
          placeholder: "Name",
          maxlength: "32"
        }, null, 512), [
          [_vModelText, compState.memo]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "ageVerificationRequired",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.ageVerificationRequired) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.ageVerificationRequired]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            class: "form-check-label",
            for: "ageVerificationRequired"
          }, "Age Verification Required", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "noMembershipDiscountAllowed",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.noMembershipDiscountAllowed) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.noMembershipDiscountAllowed]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            class: "form-check-label",
            for: "noMembershipDiscountAllowed"
          }, "No Membership Discount Allowed", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "nonDiscountable",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.nonDiscountable) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.nonDiscountable]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "form-check-label",
            for: "nonDiscountable"
          }, "Non Discountable", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "nonSurchargeable",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.nonSurchargeable) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.nonSurchargeable]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            class: "form-check-label",
            for: "nonSurchargeable"
          }, "Non Surchargeable", -1))
        ])
      ])
    ])
  ]))
}
}

})